export class PageOf<T> {

    constructor(
        public page: number,
        public pageSize: number,
        public totalItems: number,
        public currentPage: Array<T>) {
    }
}
